import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";
import { useEffect } from "react";
import L from "leaflet";
import { Link } from "react-router-dom";

const COLOR = { healthy: "#16A34A", warning: "#F97316", critical: "#EF4444" };

function FitBounds({ plants }) {
    const map = useMap();
    useEffect(() => {
        const valid = plants.filter(p => p.lat && p.lng);
        if (valid.length === 0) return;
        if (valid.length === 1) {
            map.setView([valid[0].lat, valid[0].lng], 12);
            return;
        }
        const bounds = L.latLngBounds(valid.map(p => [p.lat, p.lng]));
        map.fitBounds(bounds, { padding: [40, 40], maxZoom: 11 });
    }, [plants, map]);
    return null;
}

export default function FleetMap({ plants }) {
    const valid = plants.filter(p => p.lat && p.lng);
    return (
        <div className="h-[420px] rounded-sm overflow-hidden border border-zinc-200" data-testid="fleet-map">
            <MapContainer center={[22.5, 78.9]} zoom={5} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
                <TileLayer
                    attribution='&copy; OpenStreetMap contributors'
                    url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <FitBounds plants={plants} />
                {valid.map((p) => (
                    <CircleMarker
                        key={p.id}
                        center={[p.lat, p.lng]}
                        radius={10}
                        pathOptions={{ color: COLOR[p.health] || "#0A0A0A", fillColor: COLOR[p.health] || "#0A0A0A", fillOpacity: 0.85, weight: 2 }}
                    >
                        <Popup>
                            <div className="text-xs font-sans" style={{ fontFamily: 'Outfit' }}>
                                <div className="font-semibold text-zinc-900 mb-0.5">{p.customer_name || p.name}</div>
                                {p.location && <div className="text-[10px] font-mono text-zinc-500 mb-1">{p.location}</div>}
                                <div className="text-zinc-600 mb-2">{p.address}</div>
                                <div className="font-mono text-zinc-700">
                                    {p.current_power_kw?.toFixed(1)} / {p.installed_capacity_kw} kW
                                </div>
                                <Link to={`/plants/${p.id}`} className="text-[#0A0A0A] font-medium mt-2 inline-block">View plant →</Link>
                            </div>
                        </Popup>
                    </CircleMarker>
                ))}
            </MapContainer>
        </div>
    );
}
